<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="map-container">
	<globalictcc-chart
		chartType="map"
		[data]="isMapReady() ? data : undefined"
		[configOverrides]="effectiveConfigOverrides"
		[hasError]="hasError || hasMapError()"
		[isLoading]="isLoading || isMapLoading()"
		[isGradient]="isGradient"
		[patterns]="patterns"
		[colors]="colors"
		[isTitleVisible]="isTitleVisible"
		[isLegendVisible]="isLegendVisible"
		[titleAlignment]="titleAlignment"
		[titleSize]="titleSize"
		[tooltip]="tooltip"
		(handleChartRefresh)="refresh()"
		(handleChartInit)="onChartInit($event)"
		(handleChartClick)="onChartClick($event)"
	/>

	@if (popupLabel) {
		<div
			class="map-popup"
			[style.left.px]="popupPosition.x"
			[style.top.px]="popupPosition.y"
		>
			<div class="map-popup-header">
				<span>{{ popupLabel }}</span>
				<button
					type="button"
					class="map-popup-close"
					aria-label="Close popup"
					(click)="closePopup()"
				>
					&times;
				</button>
			</div>
		</div>
	}

	<div class="map-controls">
		<div class="map-control controller">
			@if (isControllerVisible) {
				<div class="map-controller">
					<div class="map-controller-close">
						<globalictcc-button
							label="Close"
							[textOnly]="true"
							iconName="close"
							iconPosition="right"
							(handleClick)="isControllerVisible = false"
						/>
					</div>

					<div class="directions">
						<div class="map-controller-arrow-up">
							<globalictcc-button
								iconName="arrow-up"
								[iconOnly]="true"
								(handleClick)="move('up')"
							/>
						</div>

						<div class="map-controller-arrow-left-right">
							<globalictcc-button
								iconName="arrow-left"
								[iconOnly]="true"
								(handleClick)="move('left')"
							/>

							<globalictcc-button
								iconName="arrow-right"
								[iconOnly]="true"
								(handleClick)="move('right')"
							/>
						</div>

						<div class="map-controller-arrow-down">
							<globalictcc-button
								iconName="arrow-down"
								[iconOnly]="true"
								(handleClick)="move('down')"
							/>
						</div>
					</div>
				</div>
			} @else {
				<globalictcc-button
					class="map-control-btn"
					iconName="junction"
					[iconOnly]="true"
					(handleClick)="isControllerVisible = true"
				/>
			}
		</div>

		<div class="map-control zoom">
			<globalictcc-button
				class="map-control-btn"
				iconName="plus"
				[iconOnly]="true"
				[disabled]="currentZoom === maxZoom"
				(handleClick)="zoomIn()"
			/>

			<div class="map-control-zoom-divider"></div>

			<globalictcc-button
				class="map-control-btn"
				iconName="minus"
				[iconOnly]="true"
				[disabled]="currentZoom === minZoom"
				(handleClick)="zoomOut()"
			/>
		</div>
	</div>
</div>
